
import Routers from "./routers/Routers";
import ScrollToTop from './component/Scrool'
function App() {
    return (
        <>
            <ScrollToTop />
            <Routers />
        </>
    );
}

export default App;
